import { render, staticRenderFns } from "./UpdateProductOrderItemsPopUp.vue?vue&type=template&id=6d15805d&scoped=true&"
import script from "./UpdateProductOrderItemsPopUp.vue?vue&type=script&lang=js&"
export * from "./UpdateProductOrderItemsPopUp.vue?vue&type=script&lang=js&"
import style0 from "./UpdateProductOrderItemsPopUp.vue?vue&type=style&index=0&id=6d15805d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d15805d",
  null
  
)

export default component.exports